export default {
  'pages.layouts.userLayout.title':
    'Ant Design adalah spesifikasi desain Web yang paling berpengaruh di Kabupaten Xihu',
  'pages.login.accountLogin.tab': 'Login dengan akun',
  'pages.login.accountLogin.errorMessage': 'Nama pengguna dan kata sandi salah(admin/ant.design)',
  'pages.login.failure': 'Log masuk gagal, silakan coba lagi!',
  'pages.login.success': 'Login berhasil!',
  'pages.login.username.placeholder': 'nama pengguna: admin atau user',
  'pages.login.username.required': 'Nama pengguna harus diisi!',
  'pages.login.password.placeholder': 'kata sandi: ant.design',
  'pages.login.password.required': 'Kata sandi harus diisi!',
  'pages.login.phoneLogin.tab': 'Login dengan ponsel',
  'pages.login.phoneLogin.errorMessage': 'Kesalahan kode verifikasi',
  'pages.login.phoneNumber.placeholder': 'masukkan nomor telepon',
  'pages.login.phoneNumber.required': 'Nomor ponsel harus diisi!',
  'pages.login.phoneNumber.invalid': 'Nomor ponsel tidak valid!',
  'pages.login.captcha.placeholder': 'kode verifikasi',
  'pages.login.captcha.required': 'Kode verifikasi diperlukan!',
  'pages.login.phoneLogin.getVerificationCode': 'Dapatkan kode',
  'pages.getCaptchaSecondText': 'detik tersisa',
  'pages.login.rememberMe': 'Ingat saya',
  'pages.login.forgotPassword': 'Lupa Kata Sandi?',
  'pages.login.submit': 'Masuk',
  'pages.login.loginWith': 'Masuk dengan :',
  'pages.login.registerAccount': 'Daftar Akun',
  'pages.welcome.link': 'Selamat datang',
  'pages.welcome.alertMessage':
    'Komponen heavy-duty yang lebih cepat dan lebih kuat telah dirilis.',
  'pages.404.subTitle': 'Maaf, halaman yang Anda kunjungi tidak ada. ',
  'pages.404.buttonText': 'Kembali ke halaman utama',
  'pages.admin.subPage.title': 'Halaman ini hanya dapat dilihat oleh admin',
  'pages.admin.subPage.alertMessage':
    'umi ui telah dirilis, silahkan gunakan npm run ui untuk memulai pengalaman.',
  'pages.searchTable.createForm.newRule': 'Aturan baru',
  'pages.searchTable.updateForm.ruleConfig': 'Konfigurasi aturan',
  'pages.searchTable.updateForm.basicConfig': 'Informasi dasar',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nama aturan',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Harap masukkan nama aturan!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Deskripsi aturan',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Harap masukkan setidaknya lima karakter',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Harap masukkan deskripsi aturan setidaknya lima karakter!',
  'pages.searchTable.updateForm.ruleProps.title': 'Properti aturan',
  'pages.searchTable.updateForm.object': 'Objek pemantauan',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Template aturan',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Jenis aturan',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Periode penjadwalan',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Waktu mulai',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Pilih waktu mulai!',
  'pages.searchTable.titleDesc': 'deskripsi',
  'pages.searchTable.ruleName': 'Nama aturan wajib diisi',
  'pages.searchTable.titleCallNo': 'Jumlah panggilan',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'menyala',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Waktu terjadwal',
  'pages.searchTable.exception': 'Harap masukkan alasan pengecualian!',
  'pages.searchTable.titleOption': 'Pengoperasian',
  'pages.searchTable.config': 'Konfigurasi',
  'pages.searchTable.subscribeAlert': 'Berlangganan notifikasi',
  'pages.searchTable.title': 'Formulir pertanyaan',
  'pages.searchTable.new': 'Baru',
  'pages.searchTable.chosen': 'Terpilih',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Jumlah total panggilan layanan',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'Penghapusan batch',
  'pages.searchTable.batchApproval': 'Persetujuan batch',

  // Public Holiday Management
  'holidayManagement.title': 'Manajemen Hari Libur Nasional',
  'holidayManagement.content': 'Mengelola hari libur nasional untuk organisasi Anda',
  'holidayManagement.holidayList': 'Daftar Hari Libur',
  'holidayManagement.addNewHoliday': 'Tambah Hari Libur Baru',
  'holidayManagement.editHoliday': 'Edit Hari Libur',
  'holidayManagement.addHoliday': 'Tambah Hari Libur',
  'holidayManagement.createSuccess': 'Hari libur berhasil dibuat',
  'holidayManagement.updateSuccess': 'Hari libur berhasil diperbarui',
  'holidayManagement.deleteSuccess': 'Hari libur berhasil dihapus',
  'holidayManagement.deleteFailed': 'Gagal menghapus',
  'holidayManagement.operationFailed': 'Operasi gagal',
  'holidayManagement.deleteConfirm': 'Apakah Anda yakin ingin menghapus hari libur ini?',
  'holidayManagement.name': 'Nama Hari Libur',
  'holidayManagement.description': 'Deskripsi',
  'holidayManagement.date': 'Tanggal',
  'holidayManagement.countryCode': 'Negara',
  'holidayManagement.stateCode': 'Negara Bagian/Wilayah',
  'holidayManagement.isNational': 'Hari Libur Nasional',
  'holidayManagement.status': 'Status',
  'holidayManagement.action': 'Aksi',
  'holidayManagement.edit': 'Edit',
  'holidayManagement.delete': 'Hapus',
  'holidayManagement.yes': 'Ya',
  'holidayManagement.no': 'Tidak',
  'holidayManagement.active': 'Aktif',
  'holidayManagement.inactive': 'Tidak Aktif',
  'holidayManagement.searchName': 'Cari nama hari libur',
  'holidayManagement.searchDescription': 'Cari deskripsi',
  'holidayManagement.holidayName': 'Nama Hari Libur',
  'holidayManagement.pleaseEnterHolidayName': 'Silakan masukkan nama hari libur',
  'holidayManagement.pleaseSelectDate': 'Silakan pilih tanggal',
  'holidayManagement.pleaseSelectCountry': 'Silakan pilih negara',
  'holidayManagement.pleaseSelectState': 'Silakan pilih negara bagian/wilayah',
  'holidayManagement.isActive': 'Aktif',
  'holidayManagement.showing': 'Menampilkan',
  'holidayManagement.of': 'dari',
  'holidayManagement.items': 'item',

  // Nama Hari Libur Nasional Hong Kong
  'holidayManagement.holidayNames.newYearsDay': 'Tahun Baru',
  'holidayManagement.holidayNames.lunarNewYearsDay': 'Tahun Baru Imlek',
  'holidayManagement.holidayNames.secondDayOfLunarNewYear': 'Hari Kedua Tahun Baru Imlek',
  'holidayManagement.holidayNames.thirdDayOfLunarNewYear': 'Hari Ketiga Tahun Baru Imlek',
  'holidayManagement.holidayNames.chingMingFestival': 'Festival Ching Ming',
  'holidayManagement.holidayNames.goodFriday': 'Jumat Agung',
  'holidayManagement.holidayNames.dayFollowingGoodFriday': 'Hari setelah Jumat Agung',
  'holidayManagement.holidayNames.easterMonday': 'Senin Paskah',
  'holidayManagement.holidayNames.labourDay': 'Hari Buruh',
  'holidayManagement.holidayNames.buddhaBirthday': 'Hari Lahir Buddha',
  'holidayManagement.holidayNames.tuenNgFestival': 'Festival Tuen Ng',
  'holidayManagement.holidayNames.hkEstablishmentDay':
    'Hari Pembentukan Daerah Administratif Khusus Hong Kong',
  'holidayManagement.holidayNames.nationalDay': 'Hari Nasional',
  'holidayManagement.holidayNames.dayFollowingMidAutumn':
    'Hari setelah Festival Pertengahan Musim Gugur Tiongkok',
  'holidayManagement.holidayNames.chungYeungFestival': 'Festival Chung Yeung',
  'holidayManagement.holidayNames.christmasDay': 'Hari Natal',
  'holidayManagement.holidayNames.firstWeekdayAfterChristmas': 'Hari kerja pertama setelah Natal',
  'holidayManagement.quickAddCommonHoliday': 'Tambah Hari Libur Umum dengan Cepat',
  'holidayManagement.originalName': 'Nama asli',
};
